import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  category: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({ slug, title, excerpt, image, category, date, readTime }: ArticleCardProps) {
  return (
    <Link
      to={`/articles/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-primary-500">
          {category}
        </span>
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}